import { useHistory } from "react-router-dom";
import { useMemo, useCallback } from "react";
import pin from "../../../static/assets/Pin.svg";
import { resolveSuperContainerForZoneSite } from "../core/utils/characterizationViewMode";

const formatTitleCase = (text) => {
  if (!text) return "";
  return text
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const SiteCard = ({
  site,
  superContainers,
  containers,
  titleOverride = null,
  compact = false,
}) => {
  const history = useHistory();
  const superContainer = useMemo(
    () => resolveSuperContainerForZoneSite(superContainers, site),
    [site, superContainers],
  );
  const handleCardClick = useCallback(() => {
    history.push(`/characterization/list/${site._id}`, {
      zone: site,
      superContainer,
      containers,
    });
  }, [history, site, containers, superContainer]);
  return (
    <button
      type="button"
      className={`char-site-card ${compact ? "char-site-card-compact mb-2" : ""}`}
      onClick={handleCardClick}
    >
      {!compact && (
        <p className="char-site-card-title">
          {titleOverride ?? formatTitleCase(site.addressName)}
        </p>
      )}
      <div className="char-site-card-meta">
        <img
          src={pin}
          alt=""
          className="char-site-card-meta-icon"
          aria-hidden
        />
        <span className="char-site-card-meta-label">
          {compact
            ? titleOverride ||
              (site.positioning
                ? site.positioning.charAt(0).toUpperCase() +
                  site.positioning.slice(1)
                : "")
            : site.positioning
              ? site.positioning.charAt(0).toUpperCase() +
                site.positioning.slice(1)
              : ""}
        </span>
      </div>
    </button>
  );
};
export default SiteCard;
